import _objectSpread from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var Table = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    striped = _ref.striped,
    bordered = _ref.bordered,
    borderless = _ref.borderless,
    hover = _ref.hover,
    size = _ref.size,
    variant = _ref.variant,
    responsive = _ref.responsive,
    props = _objectWithoutProperties(_ref, ["bsPrefix", "className", "striped", "bordered", "borderless", "hover", "size", "variant", "responsive"]);
  var decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'table');
  var classes = classNames(className, decoratedBsPrefix, variant && "".concat(decoratedBsPrefix, "-").concat(variant), size && "".concat(decoratedBsPrefix, "-").concat(size), striped && "".concat(decoratedBsPrefix, "-striped"), bordered && "".concat(decoratedBsPrefix, "-bordered"), borderless && "".concat(decoratedBsPrefix, "-borderless"), hover && "".concat(decoratedBsPrefix, "-hover"));
  var table = /*#__PURE__*/_jsx("table", _objectSpread({}, props, {
    className: classes,
    ref: ref
  }));
  if (responsive) {
    var responsiveClass = "".concat(decoratedBsPrefix, "-responsive");
    if (typeof responsive === 'string') {
      responsiveClass = "".concat(responsiveClass, "-").concat(responsive);
    }
    return /*#__PURE__*/_jsx("div", {
      className: responsiveClass,
      children: table
    });
  }
  return table;
});
export default Table;